import { makeStyles, Theme, createStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    orderDetails: {
      color: theme.palette.text.secondary,
    },
  })
);
